export enum RateWeightTypeEnum {
  GROSS_WEIGHT = "GROSS_WEIGHT",
  PIECES = "PIECES",
  SHIPMENT = "SHIPMENT",
  CHARGEABLE_WEIGHT = "CHARGEABLE_WEIGHT",
}
